// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_LxW","cls2":"PaywallPage-cls2_aF4 PaywallPage-cls1_LxW"};